module.exports = __webpack_public_path__ + "img/storefront-ai.4aff84fd.png";